import { Link } from "react-router-dom"

export const NotFoundPage = () => {
  const role = localStorage.getItem("role")

  const backLink =
    role === "mentor"
      ? "/profile"
      : role === "admin"
      ? "/courses"
      : "/login"

  const backText =
    role === "mentor"
      ? "Вернуться в профиль"
      : role === "admin"
      ? "Перейти к курсам"
      : "Перейти к логину"

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 px-4">
      <div className="max-w-md text-center bg-white rounded-2xl shadow-xl p-8">
        {/* Иллюстрация */}
        <img
          src="https://illustrations.popsy.co/gray/falling.svg"
          alt="Page not found"
          className="mx-auto mb-6 h-48"
        />

        {/* Текст */}
        <h1 className="text-6xl font-bold text-gray-800">404</h1>
        <p className="mt-3 text-gray-600">
          Кажется, такой страницы не существует
        </p>
        <p className="mt-1 text-sm text-gray-400">
          Возможно, ссылка устарела или была введена неверно
        </p>

        {/* Кнопка */}
        <Link
          to={backLink}
          className="inline-block mt-6 rounded-lg bg-blue-600 px-6 py-2.5
                     text-white text-sm font-medium
                     hover:bg-blue-700 active:scale-[0.98] transition"
        >
          {backText}
        </Link>
      </div>
    </div>
  )
}
